import NewsCard from "../../../Components/NewsCard/NewsCard";
import { useTranslation } from "../../../i18n/LanguageProvider";

function LatestNewsSidebar({ news, loading }) {
    const { t } = useTranslation();

    return (
        <aside className="news-detail__sidebar" aria-labelledby="latest-news-title">
            <h2 id="latest-news-title" className="news-detail__sidebar-title">
                {t("news.latest")}
            </h2>

            {loading ? (
                <p className="news-detail__empty">{t("news.loading")}</p>
            ) : news.length > 0 ? (
                <div className="news-detail__latest-list">
                    {news.map((item) => (
                        <NewsCard key={item.id} news={item} />
                    ))}
                </div>
            ) : (
                <p className="news-detail__empty">{t("news.empty")}</p>
            )}
        </aside>
    );
}

export default LatestNewsSidebar;
